// extracted by mini-css-extract-plugin
module.exports = {"subTitle_placeholder":"SubTitle_subTitle_placeholder__1puLZ","subTitleBold":"SubTitle_subTitleBold__26uQy"};